<script setup lang="ts">
import type { AppReview } from '~/types/product.model'

defineProps<{
  review: AppReview
}>()
</script>

<template>
  <div class="review">
    <div class="review__details">
      <ProductReviewRatingStars :rating="review.rating" />
      <span class="review__full-name">{{ review.reviewer.full_name || 'Sendcloud user' }}</span>
      {{ review.reviewer.country?.name }}
      <NuxtTime
        :datetime="new Date(review.created_at)"
        year="numeric"
        month="2-digit"
        day="2-digit"
      />
    </div>
    <div class="review__text">
      {{ review.text }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/assets/styles/helpers' as *;

.review {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid var(--app-color-border-line);
  padding: var(--app-spacer-12) 0;
  gap: var(--app-spacer-12);
}

.review__details {
  display: flex;
  flex-direction: column;
  width: 160px;
}

.review__full-name {
  @extend %font-16-24-bold;

  overflow-wrap: break-word;
  margin-top: var(--app-spacer-8);
}

.review__text {
  flex: 1;
}
</style>
